import React from 'react'
import { connect } from 'react-redux'
import { Box, ButtonBase } from '@mui/material'
import { ArrowLeft, ArrowRight } from '@mui/icons-material'
import { toggleShowLeft } from '../redux/actions/appear'

const ToggleLeft = ({ showLeft, toggleShowLeft }) => {
  return (
    <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
      <ButtonBase onClick={toggleShowLeft}>
        {showLeft ? <ArrowLeft size="small" /> : <ArrowRight size="small" />}
      </ButtonBase>
    </Box>
  )
}

export default connect(
  state => ({
    showLeft: state.appear.showLeft
  }),
  dispatch => ({
    toggleShowLeft: () => dispatch(toggleShowLeft())
  })
)(ToggleLeft)
